export default {
  CREATE: `Créer une étiquette`,
  DELETE_BUTTON: {
    TITLE: `Supprimer l'étiquette`,
    SUMMARY: `Étes-vous certain de vouloir supprimer cette étiquette?`,
    PRIMARY_ACTION: `Supprimer l'étiquette`,
    BAD_MATCH: `La saisie ne correspond pas au mot "SUPPRIMER"`,
    FIELD_IS_REQUIRED: `Ce champ est requis`,
    DELETE: {
      LABEL: `Entrez "SUPPRIMER" pour confirmer`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  LIST: {
    TITLE: `Liste des étiquettes`
  },
  ICON: `Icône`,
  TYPE: `Type`,
  PRONOUN: `Préposition/article`,
  ADDRESS: `Adresse`,
  AMOUNT: `Montant (paie)`,
  PREMIUM_TYPE: `Type de prime (paie)`,
  REGIONAL_TAG: `Région`,
  IMPORT_CODE: `Code d'import`,
  CUSTOM_FIELD_1: `Champ personnalisé 1`,
  REGIONALTAGS: `Région`,
  REGIONAL: `Région`,
  WAGEPREMIUMS: `Prime salariale`,
  HOUR: `À l'heure`,
  SHIFT: `Par quart`,
  MULTIPLICATOR: `Multiplicateur salarial`,
  LOCATIONS: `Emplacement`,
  CLIENTS: `Client`,
  RESOURCES: `Ressource`,
  CUSTOM: `Personnalisée`,
  CUSTOMTAGS: `Personnalisée`,
  WILL_BE_IMPACTED: `La quantité d'éléments qui seront impactés (supprimés ou réassignés)`,
  DELETE_AMOUNT_SHIFT: `Quarts de travail`,
  DELETE_AMOUNT_PROJECTS: `Projets`,
  DELETE_AMOUNT_TEMPLATE: `Modèles d'horaires`,
  DELETE_AMOUNT_TEMPLATE_EVENTS: `Quarts de travail dans un modèle d'horaire`,
  DELETE_AMOUNT_PUNCH_CARD: `Cartes de temps`,
  DELETE_AMOUNT_USERS: `Utilisateurs`,
  DELETE_AMOUNT_LOCATIONS: `Emplacements`,
  CSV_EXPORT_NAME: `export_etiquettes_{{date}}`,
  form: {
    CREATE: {
      TITLE: `Créer une étiquette`
    },
    EDIT: {
      TITLE: `Modifier une étiquette`
    },
    NAME: {
      LABEL: `Nom de l'étiquette`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement le repérer.`,
      PLACEHOLDER: `Entrez un nom pour l'étiquette`
    },
    TYPE: {
      LABEL: `Type d'étiquette`,
      DESCRIPTION: `Détermine s'il s'agit d'une étiquette de client, d'emplacement, de ressource ou de région. Certaines étiquettes ne peuvent être assignées qu'aux quarts de travail.`
    },
    PRONOUN: {
      LABEL: `Préposition/article`,
      DESCRIPTION: `Est utilisé pour indiquer l'emplacement du quart de travail lors des appels téléphoniques et dans l'application.`
    },
    PREMIUMTYPE: {
      LABEL: `Type de premium`,
      DESCRIPTION: `Détermine s'il s'agit d'une prime à l'heure, au quart ou bien d'un multiplicatif sur le salaire.`
    },
    AMOUNT: {
      LABEL: `Montant`,
      DESCRIPTION: `Selon le type de prime, le montant va s'ajouter au salaire à un taux fixe ou bien à un taux variable selon le nombre d'heures. Il peut aussi être utilisé pour multiplier le salaire.`,
      PLACEHOLDER: `Entrez le montant`
    },
    CUSTOMFIELD1: {
      LABEL: `Champ personnalisable 1`,
      DESCRIPTION: `Ce champ est utilisé par certaines intégrations.`,
      PLACEHOLDER: `Entrez la valeur pour le champ personnalisable 1`
    },
    REGIONALTAG: {
      LABEL: `Région`,
      DESCRIPTION: `Sélectionnez la région de l'emplacement`
    },
    IMPORTCODE: {
      LABEL: `Code d'importation`,
      DESCRIPTION: `Utilisé dans les outils d'importation afin d'assigner des étiquettes à des utilisateurs.`,
      PLACEHOLDER: `Entrez un code`
    },
    ADDRESS: {
      ROOM: {
        LABEL: `Salle/Appartement`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Entrez le numéro de la salle ou de l'appartement.`
      },
      FLOOR: {
        LABEL: `Étage`,
        PLACEHOLDER: `Entrer l'étage`,
        DESCRIPTION: ``
      },
      STREET_NUMBER: {
        LABEL: `Numéro`,
        PLACEHOLDER: `Entrer le numéro`,
        DESCRIPTION: ``
      },
      ROUTE: {
        LABEL: `Adresse`,
        PLACEHOLDER: `Entrer l'adresse`,
        DESCRIPTION: ``
      },
      LOCALITY: {
        LABEL: `Ville`,
        PLACEHOLDER: `Entrer la ville`,
        DESCRIPTION: ``
      },
      ADMINISTRATIVE_AREA_LEVEL_1: {
        LABEL: `Province/État`,
        PLACEHOLDER: `Entrer la province/l'état`,
        DESCRIPTION: ``
      },
      POSTAL_CODE: {
        LABEL: `Code postal`,
        PLACEHOLDER: `Entrer le code postal`,
        DESCRIPTION: ``
      },
      COUNTRY: {
        LABEL: `Pays`,
        PLACEHOLDER: `Entrer le pays`,
        DESCRIPTION: ``
      }
    },
    NAME_REQUIRED: `Le nom de l'étiquette est requis.`,
    TYPE_REQUIRED: `Le type de l'étiquette est requis.`,
    SHOWINEMPLOYEESCHEDULE: {
      LABEL: `Afficher dans l'horaire des employés`,
      DESCRIPTION: `Détermine si l'étiquette doit être affichée sur l'horaire des employés.`
    }
  }
}
